export class UserCreatePayload {
  fullName!: string;
  loginId!: string;
  clientId!: number;
  password!: string;
  emailId!: string;
  phoneNo!: string | null;
  isActive!: 'YES' | 'NO';

  roleId = {
    roleId: 0
  };

  deptId = {
    deptId: 1
  };
}